

























import { Component, Vue , Watch} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { CoreStateInterface } from '../interfaces/coreState';
import { AuthStateInterface } from 'modules/auth/interfaces/authState';
import menuConfig from '../configs/menu';
import { MenuItem } from 'element-ui';
import { SubscriptionStatus } from 'modules/auth/enums/subscriptionStatus';
import environment from '@/environment';
import { Environments } from '../enums/enivronments';
import { ProfileApi } from '@/modules/profile/api/profile';

@Component({
    name: 'app-sidebar',
})
export default class AppSidebar extends Vue {
    public initActiveLink: string = '/';
    public menuConfig: MenuItem[] = [];
    public subEndedAllowedLinks: string[] = [
      '/logout', '/payments',
    ];
    public profileApi: ProfileApi;
    public isShopify: boolean = false;

    get hidden() {
        return this.core.hideSidebar;
    }

    get subscriptionEnded() {
      if (this.auth && this.auth.user && this.auth.user.subscriptionStatus) {
        if (this.auth.user.subscriptionStatus !== SubscriptionStatus.SUB_ENDED) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }

    @State('core') public core!: CoreStateInterface;
    public userIsSuperuser: boolean = false;
    @State('auth') private auth!: AuthStateInterface;

    constructor() {
      super();
      this.profileApi = new ProfileApi();
    }

    public async created() {
      this.loadUser();
      this.menuConfig = menuConfig;
      await this.loadProfile();
      this.initActiveLink = this.$route.path;
    }

    public loadUser() {
      this.userIsSuperuser = this.auth.user ? this.auth.user.superuser : false;
    }

    public async loadProfile() {
      try {
        const profile = await this.profileApi.getProfile();
        this.isShopify = profile.hadShopifyIntegration;
      } catch (error) {
        this.$i18n.locale = 'pl';
      }
    }

    public canViewLink(link: string) {
      if (this.subscriptionEnded) {
        if (this.subEndedAllowedLinks.includes( link )) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }

    protected linkAllowed(config: any) {
      if (environment.production) {
        return config.allow.includes(Environments.PRODUCTION);
      }

      if (environment.staging) {
        return config.allow.includes(Environments.STAGING);
      }

      return true;
    }
}
